// extracted by mini-css-extract-plugin
export default {"pciPageLayout":"pciCommon-module__pciPageLayout--EOtzX"};